<template>
  <div class="wrapper  box_v">
    <!--头部-->
    <page-head title="新增预约办理" :btn-list="btnList" @handleBtn="handleBtn">
    </page-head>
    <div class="card-box box box_f1">
      <Card dis-hover :padding="20" class="left-card">
        <Form ref="formInline" label-position="top">
          <FormItem label="事件类型" prop="host">
            <Select v-model="eventType" @on-change="typeChange">
              <Option v-for="(item, index) in eventTypeList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="事件名称" prop="host">
            <Select v-model="smallType" @on-change="smallTypeChange">
              <Option v-for="(item, index) in selectType.children" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Form>
        <!--事项图标-->
        <div class="box mar-btm">
          <div class="form-title">事项图标</div>
          <div v-if="selectSmallType.pic" style="position: relative" @mouseenter="showMask = true"
            @mouseleave="showMask = false" @click="addIcon">
            <img class="event-cover" :src="selectSmallType.pic" />
            <div v-if="showMask" class="icon-mask">
              <input type="file" id="uploads" class="upload-btn" accept="image/png, image/jpeg, image/gif, image/jpg"
                @change="uploadImg" hidden>
              <div class="iconfont icon-bianji1"></div>
            </div>
          </div>
        </div>
        <Form label-position="top">
          <FormItem label="预约时长(天)">
            <Input v-model="addappointmentTime" type='number' />
          </FormItem>
          <FormItem label="预约限制时间">
            <TimePicker confirm v-model="limitTime" format="HH:mm" placeholder="请选择预约限制时间" style="width:100%">
            </TimePicker>
          </FormItem>
          <FormItem label="预约时间" prop="host">
            <div class="appointment-time-wrapper">
              <div class="box appointment-time" v-for="(item, index) in appointmentTime" v-if="item.id > -1">
                <div>
                  {{ item.beginWeek }}&nbsp;至&nbsp;{{ item.endWeek }}&nbsp;{{ item.beginTime }}-{{ item.endTime
                  }}&nbsp;&nbsp;&nbsp;限制:<span class="text">{{ item.limit }}</span> 人</div>
                <div class="iconfont icon-bianji edit-icon" @click="editTime(item.mockId)"></div>
                <div class="iconfont icon-quxiao1 del-icon" @click="delTime(item.mockId)"></div>
              </div>
            </div>
            <Button class="btn" type="primary" @click="addTime('edit')">添加</Button>
            <div class="appointment-time-wrapper">
              <div class="box appointment-time" v-for="(item, index) in tmentDate" v-if="item.id > -1">
                <div>
                  {{ $util.FormatDate(item.startDate, "yyyy-MM-dd") }}&nbsp;至&nbsp;{{ $util.FormatDate(item.endDate,
                    "yyyy-MM-dd") }}&nbsp;</div>
                <div class="iconfont icon-chakan edit-icon" @click="editTimeDate(item)"></div>
                <div class="iconfont icon-quxiao1 del-icon" @click="delTimeDate(item)"></div>
              </div>
            </div>
            <Button class="btn" type="primary" v-if="id" @click="addSpecialDate('edit')">添加特殊日期</Button>
          </FormItem>
          <FormItem label="办理地点">
            <div v-if="didian" class="address" @click="showmap()">{{ didian }}</div>
            <div v-else @click="showmap()" class="address address_nodata">请选择地点</div>
            <map-modal v-if="showMap" @confirm="getAddress" @cancel="showmap" :zuobiao="zuobiao"></map-modal>
          </FormItem>
          <FormItem label="联系电话">
            <Input v-model="phone" />
          </FormItem>
          <FormItem label="备注">
            <Input v-model="appointmentRemark" type="textarea" maxlength="1024" show-word-limit :rows="4" />
          </FormItem>
          <FormItem label="是否同步三方">
            <RadioGroup v-model="isSyncs">
                <Radio :value="1" label="是">是</Radio>
                <Radio :value="0" label="否">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="同步三方的服务id">
            <Input v-model="syncServiceId" />
          </FormItem>
        </Form>
      </Card>

      <Card dis-hover :padding="0" class="right-card box_f1" ref="rightcard">
        <div class="editor-wrapper">
          <div class="editor-head">温馨提示</div>
          <editor-box :height="editorHeight" @editorContent="activityContent" :content="selectSmallType.remark">
          </editor-box>
        </div>
      </Card>
    </div>
    <!--上传图片-->
    <upload-img class="upload-img" :imgArr="imgArr" :imgWidth="120" :imgHeight="75" @saveImg="saveImg" :isClick="isClick"
      :isClickE="isClickE" :imgNumber="imgNumber" :fixedNumber="fixedNum">
    </upload-img>
    <!--时间编辑的弹窗-->
    <time-modal :showModel="showTimeModel" :timeItem="timeItem" @closeModal="showTimeModel = false"
      @handleTime="handleTime"></time-modal>
    <Modal v-model="showSpecialDate" title="添加特殊日期" :mask-closable="false" width="600">
      <div class="content-box">
        <!--工作时间-->
        <div class="box mar-btm v_center">
          <div class="label" style="line-height: 35px;">日期</div>
          <DatePicker type="date" format="yyyy-MM-dd" v-model="startDate" class="input box_f1" />
          <div style="line-height: 35px;">至</div>
          <DatePicker type="date" format="yyyy-MM-dd" v-model="endDate" class="input box_f1" />
        </div>
      </div>
      <div slot="footer" class="box" style="justify-content: flex-end">
        <Button type="text" @click="showSpecialDate = false">取消</Button>
        <Button type="primary" @click="saveSpecialDate">确定</Button>
      </div>
    </Modal>

    <timeList :showModel="showSpecialDateList" :appointmentTime="appointmentTimeList" @handleTimeSave="handleTimeSave"
      @closeModal="showSpecialDateList = false"></timeList>
    <specialDateModal :showModel="showSpecialDateModal" :timeItem="SpecialTimeItem"
      @closeModal="showSpecialDateModal = false" @handleTime="handleSpecialTime"></specialDateModal>
  </div>
</template>

<script>
import uploadImg from "@/components/uploadImg";
import pageHead from '../../components/head'
import editorBox from "../../components/editorBox";
import timeModal from './appointComponents/timeModal'
import specialDateModal from './appointComponents/specialDateModal'
import timeList from './appointComponents/timeList'
import util from '../../utils/util'
import mapModal from '../../components/mapModal';
import Index from "../Shouye/index";
var mockId = 0
export default {
  name: 'appointmentEdit',
  components: {
    Index,
    pageHead,
    uploadImg,
    editorBox,
    timeModal,
    mapModal,
    timeList,
    specialDateModal
  },
  data() {
    return {
      btnList: [{
        name: '提交',
        type: 'submit',
        loading: false,
      }],
      isSyncs: '',
      isSync: '',
      syncServiceId: '',
      eventTypeList: [],//事件类型集合
      eventType: '',//选择的事件类型 即大类
      selectType: {},//选择的大类
      selectSmallType: {},//选择的小类
      smallType: '',//选择的事件名称 即小类
      showMask: false,//鼠标再图标上是否显示遮罩层
      imgArr: [],
      imgNumber: 5,
      fixedNum: [1, 1],
      isClick: 0, // 上传图片的事件触发标志
      isClickE: null, // 上传图片事件的触发对象 event
      editorHeight: '',
      addappointmentTime: '7',//预约时长
      limitTime: '20:00',
      appointmentTime: [],
      timeIndex: -1,//修改的时间项的索引值
      showTimeModel: false,//打开时间编辑框
      showSpecialDate: false,//特殊时间编辑
      showSpecialDateList: false,
      showSpecialDateModal: false,
      timeItem: {},//编辑的时间项
      SpecialTimeItem: {},//编辑的时间项
      tmentDate: [],//特殊时间项
      didian: '',//地点
      showMap: false,//展示地图选择组件
      zuobiao: {},//地点
      phone: '',//电话
      appointmentRemark: "", // 备注
      id: '',
      startDate: '',
      endDate: '',
      appointmentDateId: '',
      appointmentTimeList: []
    }
  },
  methods: {
    handleBtn(type) {
      if (type == 'submit') {
        this.submit()
      }
    },
    // 获取大类等信息
    getAppointmentList() {
      this.$get(this.urlobj.dictionaryList('appointment')).then(res => {
        this.eventTypeList = res.rows.map(item => {
          return {
            id: item.id,
            name: item.dicName,
            children: item.children.map(_item => {
              var remark
              try {
                remark = JSON.parse(_item.remark).attachment
              } catch (e) {
                remark = _item.remark
              }
              return {
                name: _item.dicName,
                id: _item.id,
                pic: _item.headPicUrl,
                remark
              }
            }),
          }
        })
        if (this.$route.query.id) {
          this.id = this.$route.query.id
          this.getAppointmentDetail()
          this.getTmentDate()
        }
      })
    },
    //选择了大类  回显对应信息
    typeChange(val) {
      //小类清空
      this.smallType = ''
      this.eventTypeList.forEach((item, index) => {
        if (item.id == val) {
          this.selectType = item
        }
      })
    },
    smallTypeChange(val) {
      this.selectType.children.forEach((item, index) => {
        if (item.id == val) {
          this.selectSmallType = item
        }
      })
      if (!this.id) this.getDefalut()
    },
    getDefalut() {
      this.$get(this.urlobj.getAppiontmentDefalut).then(res => {
        var info = res.rows[0]
        this.handelDefalutData(info)
      })
    },
    handelDefalutData(info) {
      this.phone = info.phoneNO
      this.addappointmentTime = info.residentsAppointmentTime
      this.limitTime = info.timeList && info.timeList[0].limitTime ? info.timeList[0].limitTime : '20:00'
      this.appointmentRemark = info.appointmentRemark
      this.isSyncs = info.isSync == '1' ? '是':'否'
      this.syncServiceId = info.syncServiceId
      this.didian = info.address
      this.appointmentTime = info.timeList.map(item => {
        mockId++
        return {
          beginWeek: util.handelWeek(item.beginWeek),
          beginWeekValue: item.beginWeek,
          endWeek: util.handelWeek(item.endWeek),
          endWeekValue: item.endWeek,
          beginTime: item.beginTime.slice(0, 5),
          endTime: item.endTime.slice(0, 5),
          id: item.id || '',
          mockId: mockId,
          limit: item.limitCount
        }
      })
      if (info.coordinate) {
        var reg = /[0-9]+.[0-9]+/g;
        var xy = info.coordinate.match(reg);
        this.zuobiao.value = xy.join(",");
        this.zuobiao.label = info.address;
      }
    },
    // 添加图片 触发上传图片按钮
    addIcon() {
      let oInput = document.getElementById("uploads");
      oInput.click();
    },
    // 选择文件 触发
    uploadImg(selectFileEvent) {
      this.isClick++;
      this.isClickE = selectFileEvent;
    },
    saveImg(data) {
      this.selectSmallType.pic = data.path
      this.selectSmallType.picId = data.id
    },
    activityContent(data) {
      //接收富文本中的内容
      this.selectSmallType.remark = data
    },
    //删除时间
    delTime(id) {
      // this.appointmentTime.splice(index,1)
      this.appointmentTime.forEach((item, index) => {
        if (item.mockId == id) {
          if (item.id) {
            item.id = 0 - item.id
          } else {
            this.appointmentTime.splice(index, 1)
          }
        }
      })
    },
    addSpecialDate() {
      this.timeIndex = -1
      this.timeItem = {}
      this.showSpecialDate = true
    },
    addTime() {
      console.log(this.isSync,this.syncServiceId)
      this.timeIndex = -1
      this.timeItem = {}
      this.showTimeModel = true
    },
    editTime(id) {
      var index
      this.appointmentTime.forEach((item, _index) => {
        if (item.mockId == id) {
          index = _index
        }
      })
      this.timeIndex = index
      this.timeItem = this.appointmentTime[index]
      this.showTimeModel = true
    },
    handleTime(time) {
      time = JSON.parse(JSON.stringify(time))
      time.beginWeek = util.handelWeek(time.beginWeekValue)
      time.endWeek = util.handelWeek(time.endWeekValue)
      if (!time.id) time.id = ''
      if (this.timeIndex == -1) {
        mockId++
        time.mockId = mockId
        this.appointmentTime.push(time)
      } else {
        this.appointmentTime.splice(this.timeIndex, 1, time)
      }
      this.showTimeModel = false
    },
    handleSpecialTime(time) {
      time = JSON.parse(JSON.stringify(time))
      if (!time.id) time.id = ''
      if (!time.appointmentDateId) time.appointmentDateId = this.appointmentDateId
      if (this.timeIndex == -1) {
        time.beginTime= time.beginTime + ':00'
        time.endTime= time.endTime + ':00'
        this.appointmentTimeList.push(time)
      } else {
        this.appointmentTimeList.splice(this.timeIndex, 1, time)
      }
      this.showSpecialDateModal = false
    },
    editTimeDate(data) {
      this.appointmentDateId = data.id
      this.appointmentTimeList = []
      this.$get(this.urlobj.getAppointmentDatedetail(data.id)).then(res => {
        console.log(res)
        if (res.isSucceed) {
          this.appointmentTimeList = res.rows
        } else {
          this.$Message.info(res.message)
        }
        this.showSpecialDateList = true
      })
    },
    delTimeDate(data) {
      this.$delete(this.urlobj.tmentDateDel, {
        id: data.id,
      }).then(res => {
        console.log(res)
        if (res.isSucceed) {
          this.$Message.success('删除成功')
          this.getTmentDate()
        } else {
          this.$Message.info(res.message)
        }

      })
    },
    saveSpecialDate() {
      if (!this.startDate) {
        this.$Message.info('请选择开始日期')
        return
      } else if (!this.endDate) {
        this.$Message.info('请选择结束日期')
        return
      } else if (this.startDate > this.endDate) {
        this.$Message.info('结束日期要大于开始日期')
        return
      }
      this.$post(this.urlobj.tmentDateSave, {
        appointmentId: this.id,
        startDate: this.$util.FormatDate(this.startDate, 'yyyy-MM-dd') + ' 00:00:00',
        endDate: this.$util.FormatDate(this.endDate, 'yyyy-MM-dd') + ' 23:59:59'
      }).then(res => {
        if (res.isSucceed) {
          this.$Message.success('提交成功')
          this.getTmentDate()
        } else {
          this.$Message.info(res.message)
        }
        this.showSpecialDate = false
      }).catch(e => {
        this.$Message.info(e.message)
      })
    },
    showmap() {
      this.showMap = !this.showMap;
    },
    getAddress(val) {
      this.zuobiao = val
      this.didian = val.label
      this.showmap()
    },
    handleTimeSave() {
      let { limitTime, appointmentTimeList } = this
      var data = {
        timeList: appointmentTimeList.map(item => {
          return {
            appointmentDateId: item.appointmentDateId,
            limitTime: limitTime,
            beginWeek: item.beginWeekValue,
            endWeek: item.endWeekValue,
            beginTime: item.beginTime,
            endTime: item.endTime ,
            id: item.id,
            limitCount: item.limitCount
          }
        }),
      }

      this.$post(this.urlobj.tmentTimeSave, data).then(res => {
        this.$Message.success('提交成功')
        this.showSpecialDateList = false
      }).catch(e => {

      })
    },
    submit() {
      if(this.isSyncs == '是'){
        this.isSync = 1
        if(this.syncServiceId == ''){
          this.$Message.success('请填写同步三方服务id')
          return
        }
      }else{
        this.isSync = -1
      }
      let { id,isSync, syncServiceId, selectType, selectSmallType, didian, zuobiao, phone, addappointmentTime, limitTime, appointmentTime, appointmentRemark, appointmentTimeList } = this

      var data = {
        id,
        appointmentRemark,
        eventTypeId: selectType.id,
        eventNameId: selectSmallType.id,
        headPicUrl: selectSmallType.pic,
        address: didian,
        coordinate: zuobiao.value ? JSON.stringify({
          x: zuobiao.value.split(',')[0],
          y: zuobiao.value.split(',')[1]
        }) : '',
        phoneNO: phone,
        residentsAppointmentTime: addappointmentTime,
        isSync: isSync,
        syncServiceId: syncServiceId,
        timeList: appointmentTime.map(item => {
          return {
            limitTime: limitTime,
            beginWeek: item.beginWeekValue,
            endWeek: item.endWeekValue,
            beginTime: item.beginTime + ':00',
            endTime: item.endTime + ':00',
            id: item.id,
            limitCount: item.limit
          }
        }),
        remark: selectSmallType.remark
      }
      this.btnList[0].loading = true
      this.$post(this.urlobj.submitAppointment, data).then(res => {
        this.btnList[0].loading = false
        this.$Message.success('提交成功')
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500)
      }).catch(e => {
        this.btnList[0].loading = false
      })
    },
    getAppointmentDetail() {
      this.$get(this.urlobj.getAppointmentDetail(this.id)).then(res => {
        var info = res.rows[0]
        //赋值大类 模拟一次选择大类
        this.eventType = info.eventTypeId
        this.typeChange(info.eventTypeId)
        //赋值小类  不模拟点击了   selectSmallType不是系统默认值了  手动赋值
        this.smallType = info.eventNameId
        this.selectSmallType = {
          id: info.eventNameId,
          pic: info.headPicUrl,
          remark: info.remark,
        }
        //处理其他数据
        this.handelDefalutData(info)
      })

    },
    getTmentDate() {
      this.tmentDate = []
      this.$post(this.urlobj.getTmentDate, {
        appointmentId: this.id,
        pageNum: 1,
        pageSize: 1000
      }).then(res => {
        if (res.isSucceed) {
          this.tmentDate = res.rows
        }
      })
    }
  },
  mounted() {
    this.getAppointmentList()
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    //减导航栏，标题栏，上下padding
    this.editorHeight = h - 60 - 90 - 20 - 20 - 20 - 26 + "px";
  }
}
</script>

<style scoped lang="less">
/deep/ .ivu-form .ivu-form-item-label {
  font-size: 16px;
}

.wrapper {
  min-height: 100%;
}

.text {
  display: inline-block;
  width: 25px;
  text-align: right;
}

.card-box {
  margin: 0 20px 20px;
}

.left-card {
  width: 560px;
  margin-right: 20px;
}

.form-title {
  font-size: 16px;
  margin-right: 20px;
  color: #333;
  align-self: flex-start;
}

.event-cover {
  width: 70px;
  height: 70px;
  border-radius: 4px;
  display: block;
  background: #f1f1f1;
}

.icon-mask {
  width: 70px;
  height: 70px;
  border-radius: 4px;
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  .iconfont {
    font-size: 28px;
  }
}

.editor-wrapper {
  padding: 20px;
}

.editor-head {
  line-height: 1;
  font-size: 16px;
  margin-bottom: 10px;
}

.mar-btm {
  margin-bottom: 24px;
}

.appointment-time-wrapper {
  margin-top: 10px;

  .appointment-time {
    color: #a1a1a1;
    line-height: 1;
    font-size: 15px;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    .edit-icon {
      color: #556fb5;
      font-size: 20px;
      margin: -3px 15px 0;
    }

    .del-icon {
      color: #f43f3e;
      font-size: 20px;
      margin-top: -3px;
    }
  }
}

.btn {
  min-width: 60px;
  height: 28px;
  line-height: 13px;
  display: block;
  margin-top: 15px;
}

/*选择地点的样式*/
.address {
  width: 100%;
  height: 32px;
  line-height: 24px;
  padding: 4px 7px;
  font-size: 12px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
  background-color: #fff;
  background-image: none;
  position: relative;
  cursor: text;

}

.address_nodata {
  color: #bbb
}

.address:hover {
  border: 1px solid #ff7b44;
}

.address:active {
  border: 1px solid #ff7b44;
}
</style>
